export default "/images/ic-hone-div.svg?97681628b246621ea6b430a57a9ae47f";